export const STATIC_TAXONOMY = {
  POSITION_TYPE: {
    codename: 'typ_stanowiska',
    values: {
      MANAGEMENT: 'zarzad',
      SUPERVISORY_BOARD: 'rada_nadzorcza',
      TECHNOLOGY: 'technologia',
      BUSINESS: 'biznes',
      HR: 'hr'
    }
  },
  GROUP: {
    codename: 'inicjatywa_grupa',
    values: {
      IT: 'lokalne_srodowisko_it',
      OTHER: 'otoczenie'
    }
  },
  PRESS_ROOM: {
    codename: 'kategoria_press_room',
    values: {
      SOFTWAREHUT: 'softwarehut',
      TENDERHUT: 'tenderhut',
      SOLUTION4LABS: 'solution4labs',
      PROTECTHUT: 'protecthut',
      ZONIFERO: 'zonifero',
      PROGRAMISTOK: 'programistok'
    }
  },
  REPORTS: {
    codename: 'kwartal',
    other: 'inny',
    values: {
      YEARLY: 'roczny',
      Q1: 'q1',
      Q2: 'q2',
      Q3: 'q3',
      Q4: 'q4'
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/consts/staticTaxonomy.js